import { TTMSite, NZGTTMSite } from "./types";

export const isNZGTTMSite = (site: TTMSite | NZGTTMSite): site is NZGTTMSite =>
  'projectType' in site;
